export default "__VITE_ASSET__BQ73VqhG__"